"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateCoverPrintableIfNeeded;
const CoverSurface_1 = require("../../models/CoverSurface");
// Project imports
const numbers_1 = require("../../helpers/numbers");
const either_1 = require("../../types/either");
// Local imports
const project_1 = require("../project");
const updateBookCoverPrintable_1 = __importDefault(require("./updateBookCoverPrintable"));
const Product_1 = require("../../models/Product");
/**
 * Determines if the cover printable in the given project needs to be updated because the interior page
 * count crossed a certain threshold (as defined in the Template).
 *
 * If an update needs to happen, this method will create an updated copy of the cover printable based
 * on the current page object, and place it directly in the given project.
 *
 * IMPORTANT NOTE! This method modifies the given project directly - it doesn't create a copy.
 *
 * @param template Template to use.
 * @param project Project to update.
 * @param updateTimestamp Value to set the 'lastModifiedAt' of the new printable to.
 * @returns The updated cover printable copy (if it needed to be updated), undefined (if it didn't need
 *  to be updated),or an error if something went wrong.
 */
function updateCoverPrintableIfNeeded(template, project, updateTimestamp) {
  // This function only applies to book projects; for any other project, there isn't a cover to update
  if (!(0, Product_1.isABooksCategory)(project.product.hammerCategory)) {
    return (0, either_1.right)(undefined);
  }
  const interiorPageCount = (0, project_1.getBookInteriorPageCount)(project.printableGroups, project.product.hammerCategory);
  // Get the cover printables group
  const coverPrintableGroup = project.printableGroups.find(pg => pg.type === 'cover');
  if (!coverPrintableGroup) {
    return (0, either_1.left)(new Error(`Could not find cover printable group for project ${project.id}`));
  }
  // The cover printable group will only ever have one printable in it
  const coverPrintable = coverPrintableGroup.printables[0];
  // Need to update the cover printable when:
  //  - it already has a cover surface attached to it (for backwards compatibility - project created before the coverSurface feature was created should be ignored)
  //  - the range of the current surface does not match the interior page count of the book
  const shouldUpdateCover = (0, CoverSurface_1.isCoverSurface)(coverPrintable.surface) && !(0, numbers_1.inRange)(interiorPageCount, coverPrintable.surface.pageCount.min, coverPrintable.surface.pageCount.max);
  if (shouldUpdateCover && template.coverSurfaces) {
    const updateBookCoverPrintableResult = (0, updateBookCoverPrintable_1.default)(template, coverPrintable, interiorPageCount, updateTimestamp, undefined, project.product.hammerCategory);
    if (updateBookCoverPrintableResult.isLeft()) {
      return (0, either_1.left)(updateBookCoverPrintableResult.value);
    }
    // Put the updated printable copy in the appropriate printable group
    coverPrintableGroup.printables = [updateBookCoverPrintableResult.value];
    return (0, either_1.right)(updateBookCoverPrintableResult.value);
  }
  // Cover didn't need to be updated
  return (0, either_1.right)(undefined);
}